import { SETTLEMENT_TYPE_NAMES, SETTLEMENT_TYPES } from "constants/index";
import { arsFormatter } from "helpers";
import { LiquidationSettlementType } from "types";

export const checkSettlementType = (
  liquidation_settlement_type: LiquidationSettlementType,
) => {
  switch (liquidation_settlement_type.settlement_type) {
    case SETTLEMENT_TYPES.ABONO:
      return `${arsFormatter(liquidation_settlement_type.calculation)}`;
    case SETTLEMENT_TYPES.PALLETS:
      return `${arsFormatter(
        liquidation_settlement_type.calculation,
      )} (x Pallet)`;
    case SETTLEMENT_TYPES.UNIDADES:
      return `${arsFormatter(liquidation_settlement_type.calculation)} (x Unidad)`;
    case SETTLEMENT_TYPES.PESO:
      return `${arsFormatter(liquidation_settlement_type.calculation)} (x Kg)`;
    case SETTLEMENT_TYPES.PESO_VOLUMETRICO:
      return `${arsFormatter(liquidation_settlement_type.calculation)} (x Pv)`;
    case SETTLEMENT_TYPES.VOLUMEN:
      return `${arsFormatter(liquidation_settlement_type.calculation)} (x M3)`;
    case SETTLEMENT_TYPES.SUPERFICIE:
      return `${arsFormatter(liquidation_settlement_type.calculation)} (x M2)`;
  }
};

const settlementUnitLabel = (settlementType: string) => {
  switch (settlementType) {
    case SETTLEMENT_TYPES.PALLETS:
      return "Pallet";
    case SETTLEMENT_TYPES.UNIDADES:
      return "Unidad";
    case SETTLEMENT_TYPES.PESO:
      return "Kg";
    case SETTLEMENT_TYPES.PESO_VOLUMETRICO:
      return "Pv";
    case SETTLEMENT_TYPES.VOLUMEN:
      return "M3";
    case SETTLEMENT_TYPES.SUPERFICIE:
      return "M2";
    default:
      return "";
  }
};

export const checkSettlementTypeWithMinimum = (
  liquidationSettlementType: LiquidationSettlementType,
  minimumApplied: boolean,
) => {
  const base = checkSettlementType(liquidationSettlementType);
  const minimumValue = Number(liquidationSettlementType.minimum_value ?? 0);

  if (minimumValue <= 0) return base;

  const unit = settlementUnitLabel(liquidationSettlementType.settlement_type);
  const appliedLabel = minimumApplied ? " (aplicado)" : "";

  return `${base} | Mín: ${minimumValue} ${unit}${appliedLabel}`;
};

export const settlementTypeName = (settlementType: string) => {
  return SETTLEMENT_TYPE_NAMES[settlementType];
};
